import { render, staticRenderFns } from "./vue-piczoom.vue?vue&type=template&id=1d44445e&scoped=true&"
import script from "./vue-piczoom.vue?vue&type=script&lang=js&"
export * from "./vue-piczoom.vue?vue&type=script&lang=js&"
import style0 from "./vue-piczoom.vue?vue&type=style&index=0&id=1d44445e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d44445e",
  null
  
)

export default component.exports